(function() {
	'use strict';
	angular.module('app.setup')
		.controller('customerOrderStatusCategories', customerOrderStatusCategories);

	customerOrderStatusCategories.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$compile', 'leanFilterService', 'leanTableService', 'tableRenderService', 'tableService', 'URLS', 'customerOrderStatusCategoryService'];

	function customerOrderStatusCategories($scope, $rootScope, $timeout, $uibModal, $compile, leanFilterService, leanTableService, tableRenderService, tableService, URLS, customerOrderStatusCategoryService) {

		function descriptionRenderer(row, col, rowIndex, params) {
			var extraClass = '';
			var archiveActionClass = 'fa-archive';
			var archiveAction = 'archive';
			var message = 'Click to {0} Customer order status category';
			var actionElement = '<i class="fa fa-pencil" title="' + String.format(message, 'edit') + '" ng-click="' +
				'vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'Edit Customer Order Status Category\', \'text\', 100, undefined, false)"></i>';

			if (row.stateType === 'Archived') {
				archiveActionClass = 'fa-check';
				archiveAction = 'enable';
				extraClass = 'archive';
			}

			actionElement += '<i class="fa ' + archiveActionClass + '" '
				+ 'title="' + String.format(message, archiveAction) + '" ng-click="vm.archiveCustomerOrderStatusCategory(' + row.ndx + ', ' + row.dateModified + ', \'' + row.stateType + '\')"></i>';

			return '<div class="cell-div inline-edit-cell">' +
				'<div class="edit-name-text with-delete ' + extraClass + '">' + row.description +
				'</div>' +
				'<div class="inlineActionIcons with-delete">' + actionElement + '</div>' +
				'</div>';
		}
		var columns = [
			{
				'id': 'description',
				'display': 'Category Name',
				'width': 400,
				'renderer': descriptionRenderer,
				'enablePinning': false,
				'hideMenu': true,
				'show': true
			}
		];

		var getSpecialControl;
		var vm = this;
		var reportSettingsName = 'CustomerOrderStatusCategories';

		vm.searchPlaceholderText = 'Search Customer Order Status Categories ...';
		vm.actionButtonText = 'Add Category';
		vm.broadcastAction = broadcastAction;
		vm.showActionButton = true;
		vm.reportName = 'Customer order status categories';
		vm.showExcel = false;
		vm.initialLoad = true;
		vm.archiveCustomerOrderStatusCategory = archiveCustomerOrderStatusCategory;

		$scope.processArchive = processArchive;
		var pinnedColumns = [];
		var rendererParams = {};

		var extraParams = [{
			'name': 'showArchive',
			'value': false
		}];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: 'customerOrderStatusCategories',
			noPaging: true,
			noFactory: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'description',
			defaultSortDirection: 'asc',
			rendererParams: rendererParams,
			pageSize: 50,
			reportUrl: String.format(URLS.customerOrderStatusCategoriesReportUrl, globalConfig.customer.id),
			searchType: 'customerOrderStatusCategory',
			hideSearch: true,
			extraParams:extraParams,
			setColumnDefaults: true,
			specialPlaceholderText: vm.searchPlaceholderText,
			isGlobalReportSetting: true,
			hideColumnSelector: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;

		function getData(params, extraParams, isFilterChanged) {
			return tableService.getData(params, extraParams).then(function (response) {
				return response;
			});
		}

		function getMeta() {
			return meta;
		}

		$scope.filterService = leanFilterService;
		$scope.tableService = leanTableService;
		$scope.tableService.setReportSettingsName(reportSettingsName);
		$scope.filterService.searchType = 'task';

		function init() {
			getSpecialControl = setInterval(getSpecialControls, 200);
			$scope.filterService.clearFilters();
			$scope.filterService.loadFilters();
		}

		function broadcastAction() {
			openNewCustomerOrderStatusCategory();
		}

		function openNewCustomerOrderStatusCategory() {
			var NewCustomerOrderStatusCategoryScope = $scope.$new();
			NewCustomerOrderStatusCategoryScope.action = 'Add';
			var opts = {
				scope: NewCustomerOrderStatusCategoryScope,
				templateUrl: '/application/f/setup/factory/general/customer-order-status-categories-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			NewCustomerOrderStatusCategoryScope.closeDialog = function () {
				instance.close();
				NewCustomerOrderStatusCategoryScope.$destroy();
			};

			NewCustomerOrderStatusCategoryScope.result = function (message, isSuccessful) {
				instance.close();
				NewCustomerOrderStatusCategoryScope.$destroy();
				var time = 3000;
				$rootScope.$emit('toast', {
					'message': message,
					'success': isSuccessful,
					'time': time
				});
				if (isSuccessful) $scope.$broadcast('reloadTable');
			};

			NewCustomerOrderStatusCategoryScope.addToastMessage = function (message, type) {
				$rootScope.$emit('toast', {
					'message': message,
					'success': type
				});
			};
		}

		function archiveCustomerOrderStatusCategory(customerOrderStatusCategoryNdx, lastModified, stateType) {
			var confirmScope = $scope.$new();
			var action = stateType === 'Archived' ? 'Enable': 'Archive';
			confirmScope.additionalText = action + ' this Customer Order status category';
			confirmScope.buttonText = action;
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();
				var customerOrderStatusCategory = {
					'ndx': customerOrderStatusCategoryNdx,
					'stateType': stateType === 'Archived' ? 'Active' : 'Archived'
				};
				customerOrderStatusCategoryService.updateCustomerOrderStatusCategory(customerOrderStatusCategory, (new Date(lastModified)).toUTCString()).then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {
							'message': 'Customer Order Status Category ' + action + 'd successfully'
						});
						$scope.$broadcast('reloadTable');
					} else {
						$rootScope.$emit('toast', {
							'message': 'Failed to  ' + action + ' Customer Order Status Category.',
							'success': false
						});
					}
				});
			};
		}

		var getSpecialControls = function () {
			var specialControl = document.getElementById('specialControls');

			if (specialControl) {
				clearInterval(getSpecialControl);
				addSpecialControl();
			}
		};

		function addSpecialControl() {
			var template = '<div style=\"display: inline-block;bottom: 0px;vertical-align: bottom;line-height: 27px;position: absolute;\">' +
				'<span style=\"font-weight:bold;font-size:14px;\" translate>Show Archived</span> <input type=\"checkbox\" ng-change=\"processArchive()\" ng-model=\"showArchive\"></div>';
			var compiledDiv = $compile(template)($scope);

			jQuery('#specialControls').append(compiledDiv);
		}

		function processArchive() {
			var showArchiveIndex = _.findIndex(extraParams, ['name', 'showArchive']);
			if (showArchiveIndex !== -1) {
				extraParams[showArchiveIndex].value = $scope.showArchive;
			} else {
				extraParams.push({
					'name': 'showArchive',
					'value': $scope.showArchive
				});
			}
			$scope.$broadcast('reloadTable');
		}

		init();
	}
})();
